module.exports = __webpack_public_path__ + "img/q_img05.90d319d2.jpg";